// Common color constants for the application
export const colors = {
  // Rating colors
  ratingYellow: '#FFC107',
  
  // Chart colors
  positiveGreen: '#4CAF50',
  negativeRed: '#F44336',
  
  // UI colors
  primaryBlue: '#1976d2',
  secondaryGray: '#546E7A',
  
  // Text colors
  textPrimary: '#1a2027',
  textSecondary: '#546E7A'
};

export default colors; 